import { render, staticRenderFns } from "./MomoIndex.vue?vue&type=template&id=14db4a5d&"
import script from "./MomoIndex.vue?vue&type=script&lang=js&"
export * from "./MomoIndex.vue?vue&type=script&lang=js&"
import style0 from "./MomoIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports